var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.version === 1)?[_c('NftPoolVoteV1',{attrs:{"idxArtpool":_vm.idxArtpool}})]:(_vm.version === 2)?[_c('NftPoolVoteV2',{attrs:{"idxArtpool":_vm.idxArtpool}})]:(_vm.version === 0)?void 0:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }